import logoIconJson from "@/assets/icon/logoIcon/iconfont.json"

export const logoIconList= logoIconJson.glyphs

export const profix = logoIconJson.css_prefix_text

export const font_family = logoIconJson.font_family

export const defaultIcon_app = 'yingyongzhongxin'

export const defaultIcon_worksheet = 'tubiaozhizuomoban-90'